export default function FaqItem({ post, isOpen, onToggle }) {
    

  const { id, title, content } = post;

  return (
      <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
        <button
          id={`faq-header-${id}`}
          aria-controls={`faq-panel-${id}`}
          aria-expanded={isOpen}
          className="faq-item__header"
          onClick={onToggle}
        >
          <span className="faq-item__question">{title}</span>
          <span aria-hidden="true" className="faq-item__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`faq-item__icon-svg ${isOpen ? 'faq-item__icon-svg--open' : ''}`}
              aria-hidden="true"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>
          </span>
        </button>
        <div
          id={`faq-panel-${id}`}
          role="region"
          aria-labelledby={`faq-header-${id}`}
          className={`faq-item__panel ${isOpen ? 'faq-item__panel--open' : ''}`}
        >
          <div className="faq-item__content">
            <div
              className="faq-item__answer"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>
      </div>
    );
  };